/**
 * Дата матча — объекта генерации медиа — или `null`, если её нет.
 *
 * У матча без даты бэкенд отдаёт не `null`, а начало эпохи (`1970-01-01T00:00:00+0000`), и анонс
 * печатал «01.01.1970 07:00» (IMGM-1499). Пока бэкенд не отдаёт `null`, «нет даты» — это и `null`,
 * и нулевая метка времени, и строка, которую не удалось разобрать.
 */
export function mediaSubjectMatchDate(date: string | null | undefined): Date | null {
  if (!date) return null;
  const parsed = new Date(date);
  const time = parsed.getTime();
  if (Number.isNaN(time) || time === 0) return null;
  return parsed;
}
